import Switcher from "../../Switcher";
import {customTheme, Description} from "../../../../../IntReports/LocationTab";
import Select from "react-select";
import styled from "styled-components";
import {Tab, TabList, TabPanel} from 'react-tabs';
import React, {useEffect, useState} from "react";
import EnvironmentContext from "../../EnvironmentContext";
import {useContext} from "react";
import {useForm} from "react-hook-form";
import Box from "@mui/material/Box";
import {
    ACCOUNTS_TAB, EXISTING_TECHNICAL_ENGAGEMENT_TAB,
    JEFF_USER,
    MIS_AUTOMATION4,
    OPPORTUNITIES_TAB,
    SALES_ENGINEER,
    TECHNICAL_OVERLAY,
} from "../../../../../../../utils/const/createEnvConsts";
import StepperContext from "../StepperContext";
import {useQuery} from "react-query";
import apiService from "../../../../../../../api/apiService";
import {
    accountsFromSf,
    opportunitiesByAccountId, pillars,
    regions,
    technicalEngagementByAccountID,
    technicalEngagementByOpportunityID,
    userDataFromSf,
    userDetails
} from "../../../../../../../utils/const/query-key";
import AccountDropdown from "./AccountDropdown";
import Loading from "../../../../../Loading";
import TechnicalEngagementContext from "../../TechnicalEngagementContext";
import OpportunityDropdown from "./OpportunityDropdown";
import TechnicalEngagementDropdown from "./TechnicalEngagementDropdown";
import {TabsStyled} from "../thirdStep/BluePrintCategoriesRow";
import { useLocation } from "react-router-dom";
import PartnerCustomerDemoForm from "./PartnerCustomerDemoForm";

const Form = styled.form`
  width: 500px;

  .input_text_container {
    margin-bottom: 20px;

    .account_selected {
      margin-bottom: 40px;
      color: var(--color-table-filter);
    }

    .new_technical_engagement_selected {
      margin-bottom: 72px;
    }

  }

  .input_customer_name {
    width: 100%;
    padding: 10px;
    border-radius: 4px;
    border: 1px solid var(--color-toggle-border);

    &:focus-visible {
      outline-color: #EC407A;
    }
  }
`;

const EmailInput = styled.input`
  width: 380px;
  height: 45px;
  border: 1px solid ${props => props.invalid ? 'red' : 'var(--color-table-border-pageinput)'};
  border-radius: 3px;
`;

const StepContainer = styled.div`
  display: flex;
`;

const InputWrapper = styled.div`
  margin: 20px auto 20px auto;
`;

const Button = styled.button`
  width: 75px;
  height: 36px;
  background: var(--color-workspace-bg-page-area);
  border: 1px solid var(--color-createenv-form-btn-border);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  &:hover {
    background: var(--color-table-even);
    color: var(--color-brand-pink-primary);
  }

  &.next {
    background: var(--unnamed-color-ec407a);
    background: var(--color-brand-pink-primary);
    color: var(--color-workspace-bg-page-area);
    border-radius: 2px;
    margin-right: 17px;

    ${props => props.disabled ? 'pointer-events: none;' : ''}
    ${props => props.disabled ? 'background: var(--unnamed-color-ec407a) ;' : ''}
    ${props => props.disabled ? 'background: #f1d8df;' : ''}
    &:hover {
      background: var(--color-createenv-stepper-next-btn-bg-hover);
    }
  }
`;


const TabListContainer = styled(TabList)`
  display: flex;
  padding: 0px;
  justify-content: space-between;
`;

const TabStyle = styled(Tab)`
  width: 246px;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  list-style: none;
  cursor: pointer;
  background: white;
  border: 1px solid #D9D9D9;
  color: grey;
`;


const SecondStep = (props) => {
    const {environment, setEnvironment} = useContext(EnvironmentContext);
    const {
        activeStep,
        handleNext,
        handleBack,
        regionSelected,
        setRegionSelected,
        switchLabel,
        setSwitchLabel,
        customerName,
        setCustomerName,
        technicalEngagementValue,
        setTechnicalEngagementValue,
        linkTechnicalEngagementTabIndex,
        setLinkTechnicalEngagementTabIndex,
        opportunity,
        linkDemoTabIndex,
        setLinkDemoTabIndex
    } = useContext(StepperContext);
    const {technicalEngagement, setTechnicalEngagement} = useContext(TechnicalEngagementContext);
    const [opportunityValue, setOpportunityValue] = useState("");
    const [validEmail, setValidEmail] = useState(false);
    const [technicalEngagementDropdownDisabled, setTechnicalEngagementDropdownDisabled] = useState(true);
    const {data: userData} = useQuery(userDetails, () => apiService.getUser(), {staleTime: Infinity});
    const {data: getRegionsData} = useQuery(regions, () => apiService.getRegions(), {initialData: []});
    const isPartnerFlow = Boolean(userData && !userData.isCpEmployee && (userData.isUserCenterPartner || userData.isUserCenterDistributor));
    const {
        status: userDataSfStatus,
        data: userDataSF
    } = useQuery(userDataFromSf, () => apiService.getUserDataSF(), {enabled: Boolean(userData) && !isPartnerFlow});
    const isSalesCase = Boolean(userData) && !isPartnerFlow && (
        userDataSF?.[0]?.profile.name === SALES_ENGINEER ||
        userDataSF?.[0]?.profile.name === TECHNICAL_OVERLAY ||
        userData?.userEmail === JEFF_USER ||
        userData?.userEmail === MIS_AUTOMATION4
    );
    const {
        data: opportunitiesByIdData, refetch: refetchGetOpportunities,
    } = useQuery(opportunitiesByAccountId, () => apiService.getOpportunitiesById(technicalEngagement.accountName), {enabled: false});
    const {
        data: TechnicalEngagementByOptIdData,
    } = useQuery(technicalEngagementByOpportunityID, () =>
            apiService.getTechnicalEngagementByOpptId(technicalEngagement.opportunity),
        {enabled: false}
    );
    const {status: getPillarStatus} = useQuery(pillars, () =>
        apiService.getPillars(), {enabled: isSalesCase}
    );
    const {status: getAccountsFromSfStatus} = useQuery(accountsFromSf, () =>
        apiService.getAccountFromSF(), {enabled: isSalesCase}
    );

    const {
        data: TechnicalEngagementByAccountIdData,
    } = useQuery(technicalEngagementByAccountID, () =>
            apiService.getTechnicalEngagementByAccountId(technicalEngagement.accountName),
        {enabled: false}
    );

    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    let regionParam = searchParams.get("region");
    if(0>regionParam || regionParam >3){
        regionParam=1;
    }
    useEffect(() => {
        if (getRegionsData && regionParam) {
            const foundRegion = getRegionsData.find(r => String(r.id) === String(regionParam));
            if (foundRegion) {
                const regionObj = { label: foundRegion.name, value: foundRegion.id };
                setRegionSelected(regionObj);
                setEnvironment(prev => ({ ...prev, region: foundRegion.id }));
            }
        }
        // Only run when getRegionsData or regionParam changes
    }, [getRegionsData, regionParam, setRegionSelected, setEnvironment]);

    useEffect(() => {
        if (customerName !== "") {
            refetchGetOpportunities();
        }
    }, [technicalEngagement.accountName, customerName, refetchGetOpportunities]);

    useEffect(() => {
        if (linkTechnicalEngagementTabIndex === ACCOUNTS_TAB) {
            return
        }
        if (opportunitiesByIdData?.length === 0) {
            setLinkTechnicalEngagementTabIndex(ACCOUNTS_TAB);
        } else {
            setLinkTechnicalEngagementTabIndex(OPPORTUNITIES_TAB)
        }
    }, [opportunitiesByIdData, linkTechnicalEngagementTabIndex, setLinkTechnicalEngagementTabIndex]);

    useEffect(() => {
        if (linkTechnicalEngagementTabIndex === ACCOUNTS_TAB) {
            setTechnicalEngagement(prevState => {
                return {
                    ...prevState, opportunity: ""
                }
            });
        } else {
            setTechnicalEngagement(prevState => {
                return {
                    ...prevState, opportunity: opportunityValue.value
                }
            });
        }
    }, [linkTechnicalEngagementTabIndex, opportunityValue, setTechnicalEngagement]);

    useEffect(() => {
        if (opportunity !== "" && TechnicalEngagementByOptIdData?.length === 0) {
            setTechnicalEngagementDropdownDisabled(true);
        } else if (TechnicalEngagementByAccountIdData?.length === 0) {
            setTechnicalEngagementDropdownDisabled(true);
        } else {
            setTechnicalEngagementDropdownDisabled(false);
        }
    }, [customerName, opportunity, TechnicalEngagementByOptIdData, TechnicalEngagementByAccountIdData]);

    const {register, handleSubmit} = useForm();

    if (getPillarStatus === "loading" ||
        getAccountsFromSfStatus === "loading" ||
        userDataSfStatus === "loading") {
        return <Loading/>
    }

    const onSubmit = (data) => {
        const {customer_email, customer_company_name} = data;
        const customerEmail = switchLabel === "No" ? "" : customer_email;
        const customerCompanyName = environment.customer_company_name !== "" ? environment.customer_company_name : customer_company_name
        setEnvironment(prevState => {
            return {
                ...prevState,
                customer_email: customerEmail === undefined ? "" : customerEmail,
                is_invitation: (customerEmail === undefined || customerEmail === "") ? false : true,
                customer_company_name: customerCompanyName === undefined ? "" : customerCompanyName
            }
        });
        handleNext();
    }

    const handleStepBack = () => {
        setTechnicalEngagement(prevState => {
            return {
                ...prevState, account: "", opportunity: ""
            }
        });
        handleBack();
    }

    const handleRegionSelected = (val) => {
        setEnvironment(prevState => {
            return {
                ...prevState, region: val.value
            }
        })
        setRegionSelected(val);
    };

    const isValidEmail = (e) => {
        const email = e.target.value;
        if (/\S+@\S+\.\S+/.test(email)) {
            setValidEmail(true);
        } else {
            setValidEmail(false);
        }
    }

    let content;

    if (environment.scenario === "selfTraining" || environment.scenario === "preparationDemo") {
        content = (<Form onSubmit={handleSubmit(onSubmit)} id={"second_step_form_preparationDemo"}>
            <p>Would you like to share the environment with another user?</p>
            <Switcher switchLabel={switchLabel} setSwitchLabel={setSwitchLabel}>
                <EmailInput {...register("customer_email")} type="email"
                            placeholder="Type Email Address" id={"email_input"}
                            value={environment.customer_email === "" ? undefined : environment.customer_email}
                            onChange={isValidEmail}
                            invalid={switchLabel === "Yes" && validEmail === false}
                />
            </Switcher>
            <InputWrapper>
                <Description>
                    Cloud Region <span style={{color: "red"}}>*</span>
                </Description>
                <Select
                    placeholder={<div>Select Region</div>}
                    theme={customTheme}
                    options={getRegionsData.map(region => {
                        return {label: region.name, value: region.id}
                    })}
                    value={regionSelected}
                    onChange={handleRegionSelected}
                    id={"region_dropdown"}
                />
            </InputWrapper>
            <Box sx={{mb: 2}}>
                <StepContainer>
                    <Button
                        className={'next'}
                        sx={{mt: 1, mr: 1}}
                        theme={{main: environment.scenario === "" ? "none" : ""}}
                        disabled={regionSelected === "" || (switchLabel === "Yes" && (validEmail === false && environment.customer_email === ""))}
                        type={"submit"}
                    >
                        Next
                    </Button>
                    <Button
                        className={"back"}
                        onClick={handleBack}
                        sx={{mt: 1, mr: 1}}
                        type="button"
                    >
                        {activeStep === 0 ? 'Cancel' : 'Back'}
                    </Button>
                </StepContainer>
            </Box>
        </Form>);
    } else {
        if (isSalesCase) {
            content = <Form onSubmit={handleSubmit(onSubmit)} id={"second_step_form_customerDemo"}>
                <div className={"input_text_container"}>
                    <Description>
                        Account Name <span style={{color: "red"}}>*</span>
                    </Description>
                    <AccountDropdown
                        setOpportunityValue={setOpportunityValue}
                        setTechnicalEngagementValue={setTechnicalEngagementValue}
                    />
                </div>
                <div className={"input_text_container"}>
                    <Description>
                        Link Technical Engagement to <span style={{color: "red"}}>*</span>
                    </Description>
                    <TabsStyled selectedTabClassName={"selected"}
                                onSelect={(index) => setLinkTechnicalEngagementTabIndex(index)}
                                selectedIndex={linkTechnicalEngagementTabIndex}>
                        <TabListContainer>
                            <TabStyle disabled={opportunitiesByIdData?.length === 0}
                                      className={"opportunity-tab"}>Opportunity</TabStyle>
                            <TabStyle className={"account-tab"}>Account</TabStyle>
                        </TabListContainer>
                        <TabPanel>
                            <OpportunityDropdown
                                opportunitiesByIdData={opportunitiesByIdData}
                                opportunityValue={opportunityValue}
                                setOpportunityValue={setOpportunityValue}
                                setTechnicalEngagementValue={setTechnicalEngagementValue}
                                customerName={customerName}
                            />
                        </TabPanel>
                        <TabPanel>
                            <p className={"account_selected"}>The technical engagement will be linked to the
                                selected account.</p>
                        </TabPanel>
                    </TabsStyled>
                </div>
                <div className={"input_text_container"}>
                    <Description>
                        Link Demo to<span style={{color: "red"}}>*</span>
                    </Description>
                    <TabsStyled selectedTabClassName={"selected"}
                                onSelect={(index) => setLinkDemoTabIndex(index)}
                                selectedIndex={linkDemoTabIndex}>
                        <TabListContainer>
                            <TabStyle className={"new-TE-tab"}>New Technical Engagement</TabStyle>
                            <TabStyle className={"existing-TE-tab"} disabled={technicalEngagementDropdownDisabled}>Existing
                                Technical Engagement</TabStyle>
                        </TabListContainer>
                        <TabPanel>
                            <div className={"new_technical_engagement_selected"}></div>
                        </TabPanel>
                        <TabPanel>
                            <TechnicalEngagementDropdown
                                TechnicalEngagementByAccountIdData={TechnicalEngagementByAccountIdData}
                                TechnicalEngagementByOptIdData={TechnicalEngagementByOptIdData}
                                technicalEngagementValue={technicalEngagementValue}
                                setTechnicalEngagementValue={setTechnicalEngagementValue}
                                customerName={customerName}
                            />
                        </TabPanel>
                    </TabsStyled>
                </div>
                <div className={"input_text_container"}>
                    <Description>
                        Cloud Region <span style={{color: "red"}}>*</span>
                    </Description>
                    <Select
                        placeholder={<div>Select Region</div>}
                        theme={customTheme}
                        options={getRegionsData?.map(region => {
                            return {label: region.name, value: region.id}
                        })}
                        onChange={handleRegionSelected}
                        value={regionSelected}
                        id={"region_dropdown"}
                    />
                </div>
                <Box sx={{mb: 2}}>
                    <StepContainer>
                        <Button
                            className={'next'}
                            sx={{mt: 1, mr: 1}}
                            theme={{main: environment.scenario === "" ? "none" : ""}}
                            disabled={technicalEngagement.accountName === "" ||
                                regionSelected === "" ||
                                (linkTechnicalEngagementTabIndex === OPPORTUNITIES_TAB && Object.keys(opportunity).length === 0) ||
                                customerName === "" ||
                                (linkDemoTabIndex === EXISTING_TECHNICAL_ENGAGEMENT_TAB && Object.keys(technicalEngagementValue).length === 0)
                            }
                            type={"submit"}
                        >
                            Next
                        </Button>
                        <Button
                            className={"back"}
                            onClick={handleStepBack}
                            sx={{mt: 1, mr: 1}}
                            type="button"
                        >
                            {activeStep === 0 ? 'Cancel' : 'Back'}
                        </Button>
                    </StepContainer>
                </Box>
            </Form>
        } else if (isPartnerFlow) {
            content = (
                <PartnerCustomerDemoForm
                    onSubmit={handleSubmit(onSubmit)}
                    getRegionsData={getRegionsData}
                    regionSelected={regionSelected}
                    handleRegionSelected={handleRegionSelected}
                    activeStep={activeStep}
                    handleStepBack={handleStepBack}
                />
            );
        } else {
            content = <Form onSubmit={handleSubmit(onSubmit)} id={"second_step_form_customerDemo"}>
                <div className={"input_text_container"}>
                    <Description>
                        Customer Name <span style={{color: "red"}}>*</span>
                    </Description>
                    <input className={"input_customer_name"} type={"text"}
                           {...register("customer_company_name")} maxLength={"35"}
                           placeholder={"Type customer name"} value={customerName}
                           onChange={(e) => setCustomerName(e.target.value)}/>
                </div>
                <div className={"input_text_container"}>
                    <Description>
                        Cloud Region <span style={{color: "red"}}>*</span>
                    </Description>
                    <Select
                        placeholder={<div>Select Region</div>}
                        theme={customTheme}
                        options={getRegionsData.map(region => {
                            return {label: region.name, value: region.id}
                        })}
                        onChange={handleRegionSelected}
                        value={regionSelected}
                        id={"region_dropdown"}
                    />
                </div>
                <Box sx={{mb: 2}}>
                    <StepContainer>
                        <Button
                            className={'next'}
                            sx={{mt: 1, mr: 1}}
                            theme={{main: environment.scenario === "" ? "none" : ""}}
                            disabled={customerName === "" || regionSelected === ""}
                            type={"submit"}
                        >
                            Next
                        </Button>
                        <Button
                            className={"back"}
                            onClick={handleStepBack}
                            sx={{mt: 1, mr: 1}}
                            type="button"
                        >
                            {activeStep === 0 ? 'Cancel' : 'Back'}
                        </Button>
                    </StepContainer>
                </Box>
            </Form>
        }
    }

    return (<div> {content} </div>)
}

export default SecondStep;
